(ns manatee.admin.task-config.add.handlers
  (:require
   [ajax.edn :refer [edn-response-format]]
   [kee-frame.core :as kf]
   [manatee.admin.handlers :as admin-handlers]
   [manatee.admin.rejection-option.handlers :as admin-rejection-handlers]
   [manatee.admin.task-config.handlers :as task-config-handlers]
   [manatee.annotation.handlers :as annotation]
   [manatee.components.notifications.handlers :as notifications]
   [re-frame.core :as rf]
   [taoensso.timbre :as log]))

(rf/reg-event-fx
 ::add-task
 (fn add-task
   [{:keys [db]} [_ task-config uploaded-submissions reenable-submit]]
   {:db db
    :http-xhrio {:method :post
                 :uri (kf/path-for [:api/task-configs])
                 :body (task-config-handlers/task-request-body
                        (assoc task-config :form-data? true)
                        uploaded-submissions)
                 :response-format (edn-response-format)
                 :on-success [::add-task-success reenable-submit]
                 :on-failure [::add-task-failure reenable-submit]}}))

(rf/reg-event-fx
 ::add-task-success
 (fn add-task-success
   [{:keys [db]} [_ reenable-submit _response]]
   (reenable-submit)
   {:db db
    :dispatch-n [[::annotation/load-task-configs]
                 [::notifications/add-alert :main
                  {:message [:p {:on-click #(rf/dispatch [::new-task-click])}
                             "Task config added successfully. Click here for queue configurations."]
                   :type :info}
                  :alert-id :created-task
                  :auto-dismiss? false]]}))

(rf/reg-event-fx
 ::new-task-click
 (fn [_]
   {:dispatch-n [[::notifications/clear-alert :main :created-task]
                 [:navigate-to [:manatee.admin.handlers/admin {:query-params {:tab "queue"}}]]]}))

(rf/reg-event-fx
 ::add-task-failure
 (fn add-task-failure
   [_ [_ reenable-submit info]]
   (reenable-submit)
   (log/error "Error adding task" {:info info})
   {:dispatch [::notifications/add-alert :main
               {:message (if (get-in info [:response :reason])
                           (str "Unable to add task: " (get-in info [:response :reason]))
                           "Unable to add task.")
                :type :error}
               :auto-dismiss? false]}))

(rf/reg-event-fx
 ::load-add-task-view
 (fn load-add-task-view
   [{:keys [db]}]
   {:db db
    :dispatch-n [[::admin-handlers/load-users]
                 [::admin-rejection-handlers/load-rejection-options]]}))

(kf/reg-controller ::add-task
                   {:params (fn [{:keys [handler]}]
                              (= handler ::add-task))
                    :start (fn [_ active]
                             (when active
                               [::load-add-task-view]))})
